import parse, { domToReact } from 'html-react-parser';

interface RenderHtmlProps {
  html: string;
  onLinkPress?: (href: string) => void;
}

export default function RenderHtml({ html, onLinkPress }: RenderHtmlProps) {
  const options = {
    replace: (domNode: any) => {
      if (domNode.name === 'a' && domNode.attribs) {
        const { href } = domNode.attribs;
        return (
          <a
            href={href}
            onClick={(e) => {
              e.preventDefault();
              if (onLinkPress) {
                onLinkPress(href);
              } else {
                window.open(href, '_blank'); // default behavior if no handler
              }
            }}
          >
            {domToReact(domNode.children, options)}
          </a>
        );
      }
      if (domNode.name === 'br') return <br />;
    },
  };

  return <div className='prose'>{parse(html, options)}</div>;
}
